import { useTranslation } from 'react-i18next';
import { Logo, useTheme } from '@ui';

export const CurewikiAppLogo = () => {
  const { t } = useTranslation();
  const { bgColorSecondary } = useTheme();

  return (
    <div className="flex items-center gap-0 md:gap-14">
      <div className="flex  sm:flex-row items-end sm:items-end gap-2 ">
        <div className="flex flex-col gap-1">
          <Logo height={45} />
        </div>
        <span
          className="text-[10px] leading-none text-base-100 rounded-lg px-1 py-[2px] w-fit"
          style={{ backgroundColor: bgColorSecondary }}
        >
          {t('common.beta')}
        </span>
      </div>
    </div>
  );
};
